import globalEventBus from 'toxilibs/event_bus_queued.js'
import $ from 'jquery'

let $page = $('#end_page')

globalEventBus.on('game ended', show)

globalEventBus.on('button menu clicked', hide)


let fadeDelay = 500

function show () {
    $page.fadeIn(fadeDelay)
    $('#hour_of_code_back').addClass('big')
}


function hide () {
    $page.fadeOut(fadeDelay)
    globalEventBus.emit('end page hidden')
    $('#hour_of_code_back').removeClass('big')
}

